/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popJoinArena.vue?vue&type=template&id=03bda812&scoped=true"
import script from "./popJoinArena.vue?vue&type=script&lang=js"
export * from "./popJoinArena.vue?vue&type=script&lang=js"
import style0 from "./popJoinArena.vue?vue&type=style&index=0&id=03bda812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bda812",
  null
  
)

export default component.exports